// // src/contexts/NotificationsContext.tsx

// import React, { createContext, useContext, ReactNode } from 'react';
// import { useNotifications } from '../Hooks/useNotifications';
// import userStateManager from '../AppWriteOAuth/UserStateManager';

// interface NotificationsContextType {
//   unreadCount: number;
//   isLoading: boolean;
//   fetchNotifications: () => Promise<void>;
//   markAsRead: () => Promise<void>;
//   markRequestAsViewed: (requestId: number) => void;
//   getUnreadBidsPerRequest: () => Record<number, number>;
// }

// const NotificationsContext = createContext<NotificationsContextType | undefined>(undefined);

// export const NotificationsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
//   const currentUser = userStateManager.getCurrentUser();
//   const notifications = useNotifications(currentUser?.user_type || null);

//   return (
//     <NotificationsContext.Provider value={notifications}>
//       {children}
//     </NotificationsContext.Provider>
//   );
// };

// export const useNotificationsContext = () => {
//   const context = useContext(NotificationsContext);
//   if (!context) {
//     throw new Error('useNotificationsContext must be used within NotificationsProvider');
//   }
//   return context;
// };








////////////////
// src/contexts/NotificationsContext.tsx

import React, { createContext, useContext, ReactNode } from 'react';
import { useNotifications } from '../Hooks/useNotifications';
import userStateManager from '../AppWriteOAuth/UserStateManager';

interface NotificationsContextType {
  unreadCount: number;
  isLoading: boolean;
  fetchNotifications: () => Promise<void>;
  markAsRead: () => Promise<void>;
  markRequestAsViewed: (requestId: number) => void;
  getUnreadBidsPerRequest: () => Record<number, number>;
  // ✅ დაამატე ეს 2 ახალი method:
  getUnreadJobRequests: () => Record<number, boolean>;
  markJobRequestAsViewed: (requestId: number) => void;
}

const NotificationsContext = createContext<NotificationsContextType | undefined>(undefined);

export const NotificationsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const currentUser = userStateManager.getCurrentUser();
  const notifications = useNotifications(currentUser?.user_type || null);

  return (
    <NotificationsContext.Provider value={notifications}>
      {children}
    </NotificationsContext.Provider>
  );
};

export const useNotificationsContext = () => {
  const context = useContext(NotificationsContext);
  if (!context) {
    throw new Error('useNotificationsContext must be used within NotificationsProvider');
  }
  return context;
};